import { Routes } from '@angular/router';

import { AgentGuard } from '@core/guards/agent.guard';
import { AgentFormGuard } from '@core/guards/agent-form.guard';
import { CompositeRouteGuard } from '@core/guards/composite.guard';
import { MsalGuard } from '@azure/msal-angular';

export const AgentRoutes: Routes = [
  {
    path: 'agent/life-plans',
    loadChildren: () => import('./life-plans/life-plans.module').then(m => m.LifePlansModule),
    data: { routeGuards: [AgentGuard] },
    canActivate: [MsalGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/form',
    redirectTo: 'agent/life-plans/:lifePlanId/form/personal',
    pathMatch: 'full'
  },
  {
    path: 'agent/life-plans/:lifePlanId/form/personal',
    loadChildren: () => import('./personal/personal.module').then(m => m.PersonalModule),
    data: { routeGuards: [AgentGuard, AgentFormGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/form/professional',
    loadChildren: () => import('./professional/professional.module').then(m => m.ProfessionalModule),
    data: { routeGuards: [AgentGuard, AgentFormGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/form/financial',
    loadChildren: () => import('./financial/financial.module').then(m => m.FinancialModule),
    data: { routeGuards: [AgentGuard, AgentFormGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/form/insurances',
    loadChildren: () => import('./insurances/insurances.module').then(m => m.InsurancesModule),
    data: { routeGuards: [AgentGuard, AgentFormGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/commercial-guide',
    loadChildren: () => import('./commercial-guide/commercial-guide.module').then(m => m.CommercialGuideModule),
    data: { routeGuards: [AgentGuard] },
    canActivate: [CompositeRouteGuard]
  }
];
